import { memo } from "react";
import CardUserProfile from "@/components/Card/card-user-profile";

interface IConnectionUserProfileProps {
  item: any;
  className?: string;
  cardClassName?: string;
  quickConnect?: boolean;
  onQuickConnect?: (id: string) => Promise<void>;
}

export const ConnectionUserProfile: React.FC<IConnectionUserProfileProps> = ({
  item,
  className,
  cardClassName,
  quickConnect,
  onQuickConnect = (id: string, callback?: () => void) => {},
}) => {
  return (
    <CardUserProfile
      item={item?.user}
      cgPercent={item?.CGPercent}
      isChampion={item?.isChampion}
      mutualCount={item?.mutualConnectionCount}
      key={item?.user?.id}
      points={item?.user?.points}
      avatarSize="xl"
      className={className}
      cardClassName={cardClassName}
      hideOnlyType
      quickConnect={quickConnect}
      onQuickConnect={onQuickConnect}
    />
  );
};

ConnectionUserProfile.displayName = "ConnectionUserProfile";

export default memo(ConnectionUserProfile, (prevProps, nextProps) => {
  // Only re-render if item id changes
  return prevProps.item?.user?.id === nextProps.item?.user?.id;
});
